module.exports = __webpack_public_path__ + "d5d8626e8ffbaa25f91bff3948038888.png";